import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "steps__step-number" }
const _hoisted_2 = { class: "steps__step-title-wrapper" }
const _hoisted_3 = { class: "steps__step-title" }
const _hoisted_4 = {
  key: 0,
  class: "steps__step-summary"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["steps__step", ( $setup.is_completed_step ) ? ' steps__step--completed' : ( $setup.is_current_step ) ? ' steps__step--active' : null])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString($props.step.step_number), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString($props.step.title), 1 /* TEXT */),
      ($setup.is_completed_step)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            ($setup.selected_business_development_leads.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                  _createTextVNode(" Business Development Lead: "),
                  _createElementVNode("span", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selected_business_development_leads, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: 'business-dev-leads-' + index
                      }, [
                        _createTextVNode(_toDisplayString(item.label + ( index < $setup.selected_business_development_leads.length - 1 ? ', ' : '' )), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.selected_project_managers.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                  _createTextVNode(" Project Manager: "),
                  _createElementVNode("span", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selected_project_managers, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: 'project-managers-' + index
                      }, [
                        _createTextVNode(_toDisplayString(item.label + ( index < $setup.selected_project_managers.length - 1 ? ', ' : '' )), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.is_completed_step)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "button button--smaller",
          type: "button",
          onClick: _cache[0] || (_cache[0] = $event => ($setup.setActiveStep( $props.step.step_number )))
        }, " Edit "))
      : ($setup.is_current_step)
        ? (_openBlock(), _createBlock($setup["InternalTeamFormComponent"], {
            key: 1,
            "step-title": $props.step.title
          }, null, 8 /* PROPS */, ["step-title"]))
        : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}